<app-navbar title="Sprzedaż"></app-navbar>

<div class="container col-auto my-4">
	<ng-select
		name="trips"
		[multiple]="true"
		placeholder="Wycieczka"
		[(ngModel)]="selectedTrip"
		(change)="calculated()"
	>
		<ng-option *ngFor="let item of trips" [value]="item.id"
			>{{ item.date }} | {{ item.name }} | WOLNE: {{ item.freePlaces }} [{{ item.destinations }}]
			{{ item.time }}</ng-option
		>
	</ng-select>
	<div class="row">
		<div class="col">
			<div class="form-floating my-4 col">
				<input type="number" [(ngModel)]="amount.adult" name="amountAdult" class="form-control" readonly />
				<label for="amountAdult">Dorośli:</label>
			</div>
		</div>
		<div class="col">
			<div class="form-floating my-4 col">
				<input type="number" [(ngModel)]="amount.child" name="amountChild" class="form-control" readonly />
				<label for="amountChild">Dzieci:</label>
			</div>
		</div>
	</div>
	<ng-select
		id="selectedPerson"
		name="selectedPerson"
		[(ngModel)]="selectedPerson"
		[multiple]="true"
		placeholder="Uczestnicy"
		(change)="calculated()"
	>
		<ng-option *ngFor="let item of people" [value]="item.personId"
			>{{ item.businessCaseNumber }} - {{ item.firstName }} {{ item.lastName }}</ng-option
		>
	</ng-select>
	<div class="form-floating my-4">
		<input type="text" name="priceEur" [(ngModel)]="amount.priceEUR" class="form-control" readonly />
		<label for="priceEur">Cena [EUR]</label>
	</div>
	<div class="form-floating my-4">
		<input type="text" name="priceHr" [(ngModel)]="amount.priceHR" class="form-control" readonly />
		<label for="priceHr">Cena [HR]</label>
	</div>
	<div class="form-check">
		<input
			class="form-check-input"
			type="checkbox"
			[(ngModel)]="isZero"
			name="isZero"
			id="isZero"
			(change)="calculated()"
		/>
		<label for="isZero">Wycieczka zakupiona w biurze / rekompensata</label>
	</div>
	<div class="form-floating my-4">
		<input class="form-control" type="text" [(ngModel)]="comment" name="comment" id="comment" />
		<label for="comment">Uwagi do zakupu (opcjonalne)</label>
	</div>
	<div class="d-flex flex-row-reverse">
		<a class="btn btn-primary" (click)="submit()">Rezerwuj</a>
	</div>
</div>
